import { render } from "./ControlsBottomRight.vue?vue&type=template&id=333cae2d&scoped=true"
import script from "./ControlsBottomRight.vue?vue&type=script&lang=js"
export * from "./ControlsBottomRight.vue?vue&type=script&lang=js"

import "./ControlsBottomRight.vue?vue&type=style&index=0&id=333cae2d&scoped=true&lang=scss"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333cae2d"]])

export default __exports__